import React, { useState, useEffect } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import ComboBox from '../../../../../../Components/ComboBox'
import { Input } from '../../../../../../Components/Input'
import { useForm } from 'react-hook-form'
import { makeGetRequest, makePutRequest } from '../../../../../../utils/api'
import urls from '../../../../../../utils/urls'

export default function EditOperationForm({ params, setSelected, fetchOperations }) {
  const [open, setOpen] = useState(true)
  const [unit, setUnits] = useState([])
  const [um, setUM] = useState({})

  const log = () => {
    setUM(getValues('UM'))
  }

  useEffect(() => {
    fetchFilters()
    log()
  }, [])

  const fetchFilters = async () => {
    const url = urls.getFilters + '?all=true'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      setUnits(data.unit)
    }
  }

  const { handleSubmit, control, setValue, reset, getValues } = useForm({
    defaultValues: {
      id: params[0].id,
      Nom: params[0].NomIngredient,
      NomIngredient: params[0].NomIngredient,
      Quantite: params[0].Quantite,
      Rayon: params[0].Rayon,
      UM: params[0].UM ? { label: params[0].um.Designation, id: params[0].um.id } : '',
    },
  })

  const handleClose = () => {
    setOpen(false)
    reset()
    setSelected(false)
  }

  const onSubmit = async (data) => {
    const payload = {
      ...data,
      UM: data.UM.id,
      NomIngredient: data.Nom,
    }

    const response = await makePutRequest(
      urls.crudBillofingredientsOperations + `${data.id}/`,
      payload,
      {},
      true,
    )

    if (response.status === 200) {
      fetchOperations()

      handleClose()
    }
  }

  return (
    <>
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: 'black !important' }}>Modifier Ingrédient</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="Nom"
              label="Nom Ingrédient"
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'number',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              label="Quantité"
              name="Quantite"
            />
            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue(`UM`, j)
                setUM(j)
              }}
              label="Unité"
              data={unit}
              name="UM"
              required={true}
              selectedValue={um}
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="Rayon"
              label="Rayon"
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
